<template>
    <div class="TTL-datetime" :style="{width:option.width}">
    <el-date-picker 
        v-model="inputvalue" 
        :type="option.type" 
        :format="option.format"
        :value-format="option.format" 
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        unlink-panels="true"
        :placeholder="option.placeholder" 
        :clearable="option.clearable" 
        @change="ChangeData"
        style="width:100%"
    />
    </div>
</template>

<script>
export default {
  props: ['value','option'],
  data() {
      return {
          inputvalue: this.value,
          option: {
              placeholder:this.option && this.option.placeholder ? this.option.placeholder : '请选择时间',
              clearable: this.option && this.option.clearable ? this.option.clearable : false,
              type:this.option && this.option.type ? this.option.type : 'daterange',
              width: this.option && this.option.width ? this.option.width : 'auto',
              format:this.option.format ? this.option.format : 'YYYY-MM-DD',
              ischange: this.option && this.option.ischange ? this.option.ischange : false,
          },
      }
  },

  watch: {
      value(val) {
          this.inputvalue=val;
      },
      option(val) {
          this.option=val;
      },
  },

  mounted() {
      
  },

  methods: {


      /** 修改数据，变更 **/
      ChangeData() {
          if(!this.option.ischange) return false; //数据修改变更开关关闭时，不往下执行
          this.$emit('finish',{type:'change',value:this.inputvalue});
      },

  }

}
</script>

<style scoped>
::v-deep(.el-input__wrapper) {width:auto !important;}
</style>